<div class="card" [ngClass]="cardClasses" [ngStyle]="cardStyles">
    <ng-content select="fdx-well-header"></ng-content>
    <div class="card-body" [ngClass]="cardBodyClasses" [ngStyle]="cardBodyStyles">
        <ng-content></ng-content>
    </div>
    <ng-content select="fdx-well-footer"></ng-content>
</div>